import { z } from "zod";

import { type EMHAParticipantUnbranded } from "@thalamos/common";

import {
  IncidentWorkItemWithContextSchema,
  type IncidentFormUnbranded,
  type IncidentWorkItemEnhancedUnbranded,
  type IncidentWorkItemParticipantEnhancedUnbranded,
  type IncidentWorkItemWithContextUnbranded,
} from "./incidentWorkItem.js";
import type { CreateIncidentMinimumFields } from "./workflow/index.js";

///

export type IncidentWorkItemResponse = {
  incidentWorkItem: IncidentWorkItemEnhancedUnbranded;
  participants: IncidentWorkItemParticipantEnhancedUnbranded[];
  forms: IncidentFormUnbranded[];
  emhaParticipants: EMHAParticipantUnbranded[];
};

///

export type GetIncidentWorkItemResponseUnbranded = {
  workItems: IncidentWorkItemResponse[];
};

export const GetIncidentWorkItemResponseSchema = z
  .object({
    workItems: z.array(IncidentWorkItemWithContextSchema),
  })
  .brand<"vision-common:GetIncidentWorkItemResponse">();

export type GetIncidentWorkItemResponse =
  z.infer<
    typeof GetIncidentWorkItemResponseSchema
  > extends GetIncidentWorkItemResponseUnbranded
    ? z.infer<typeof GetIncidentWorkItemResponseSchema>
    : never;

///

export type SearchIncidentWorkItemResponseUnbranded = {
  results: IncidentWorkItemWithContextUnbranded[];
  count: number;
};

export const SearchIncidentWorkItemResponseSchema = z
  .object({
    results: z.array(IncidentWorkItemWithContextSchema),
    count: z.number(),
  })
  .brand<"vision-common:SearchIncidentWorkItemResponse">();

export type SearchIncidentWorkItemResponse =
  z.infer<
    typeof SearchIncidentWorkItemResponseSchema
  > extends SearchIncidentWorkItemResponseUnbranded
    ? z.infer<typeof SearchIncidentWorkItemResponseSchema>
    : never;

///

export type CreateIncidentWorkItemRequest<
  T extends CreateIncidentMinimumFields,
> = {
  workflowVersion: string;
  createIncidentFormSection: T;
};

export type SearchIncidentWorkItemRequest = {
  officerName?: string;
  dispatchNumber?: string;
  createdDate?: string;
  subDivisionIds?: string[];
  limit: number;
  offset: number;
};
